import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { hasRole } from "./roles";

export default function RequireOrgaAccess({ children }) {
    const { user, loading } = useAuth();

    if (loading) return null;
    if (!user) return <Navigate to="/login" replace />;

    const allowed =
        hasRole(user, "admin") ||
        hasRole(user, "orga");

    if (!allowed) {
        return <Navigate to="/manager" replace />;
    }

    return children;
}
